import { take, put, call, select } from 'redux-saga/effects';

import { respawn } from 'yeself-client-common/utils/SagaUtils';

import { selectApplicationMetaDataLanguageUsedLocales } from 'Console/data/applicationDetail/settings/SettingsSelector';

import { changeConsoleLanguage, changeContentLanguage } from 'Console/data/app/actions';
import { DEFAULT_CONTENT_LANGUAGE, DEFAULT_CONSOLE_LANGUAGE } from 'Console/constants/appConstants';

import {
    CHANGE_CONSOLE_LANGUAGE,
    CHANGE_CONTENT_LANGUAGE,
    INITIALIZE_CONTENT_LANGUAGE,
    INITIALIZE_CONTENT_LANGUAGE_SUCCESS,
} from './constants';

function* changeConsoleLanguageWatcher() {
    while (true) {
        const { payload } = yield take(CHANGE_CONSOLE_LANGUAGE);
        yield call([localStorage, 'setItem'], 'yeself-console-language', JSON.stringify(payload));
    }
}

function* changeContentLanguageWatcher() {
    while (true) {
        const { payload } = yield take(CHANGE_CONTENT_LANGUAGE);
        yield call([localStorage, 'setItem'], 'yeself-content-language', JSON.stringify(payload));
    }
}

function* initConsoleLanguageTask() {
    const consoleLanguage = yield call([localStorage, 'getItem'], 'yeself-console-language');
    if (consoleLanguage) {
        yield put(changeConsoleLanguage(JSON.parse(consoleLanguage)));
    } else {
        yield put(changeConsoleLanguage(DEFAULT_CONSOLE_LANGUAGE));
    }
}

export function* initializeContentLanguageTask() {
    const preservedContentLanguageString = yield call(
        [localStorage, 'getItem'],
        'yeself-content-language'
    );
    const preservedContentLanguage = preservedContentLanguageString
        ? JSON.parse(preservedContentLanguageString)
        : null;

    const usedLocales = yield select(selectApplicationMetaDataLanguageUsedLocales);

    if (
        preservedContentLanguage &&
        usedLocales.find((language) => preservedContentLanguage.code === language.code)
    ) {
        yield put(changeContentLanguage(preservedContentLanguage));
    } else if (usedLocales.length === 0) {
        yield put(changeContentLanguage(DEFAULT_CONTENT_LANGUAGE));
    } else {
        yield put(changeContentLanguage(usedLocales[0]));
    }
    yield put({ type: INITIALIZE_CONTENT_LANGUAGE_SUCCESS });
}

function* initializeContentLanguageWatcher() {
    while (true) {
        yield take(INITIALIZE_CONTENT_LANGUAGE);
        yield call(initializeContentLanguageTask);
    }
}

function* appSaga() {
    yield respawn(initializeContentLanguageWatcher);
    yield respawn(initConsoleLanguageTask);
    yield respawn(changeConsoleLanguageWatcher);
    yield respawn(changeContentLanguageWatcher);
}

export default appSaga;
